import SafeIcon from '../common/SafeIcon';

const ComparisonToolCard = ({ tool }) => (
  <article id={tool.name.toLowerCase().replaceAll(' ', '-')} className="scroll-mt-28 rounded-3xl border border-slate-800 bg-slate-900/70 p-7">
    <div className="flex flex-wrap items-start justify-between gap-4">
      <div>
        <p className="text-sm font-bold uppercase tracking-widest text-blue-400">#{tool.rank} pick</p>
        <h2 className="mt-2 text-3xl font-extrabold text-white">{tool.name}</h2>
        <p className="mt-2 font-semibold text-slate-300">{tool.title}</p>
      </div>
      <div className="rounded-2xl bg-blue-500/10 px-4 py-3 text-right">
        <p className="text-xs uppercase tracking-wider text-slate-500">Pricing snapshot</p>
        <p className="mt-1 max-w-xs text-sm font-semibold text-blue-300">{tool.pricing}</p>
      </div>
    </div>
    <p className="mt-6 text-lg leading-relaxed text-slate-300">{tool.useCase}</p>
    <div className="mt-7 grid gap-7 md:grid-cols-3">
      <div>
        <h3 className="mb-3 font-bold text-white">Standout features</h3>
        <ul className="space-y-2 text-sm text-slate-400">
          {tool.features.map((feature) => <li key={feature} className="flex gap-2"><SafeIcon name="Check" className="mt-0.5 shrink-0 text-emerald-400" />{feature}</li>)}
        </ul>
      </div>
      <div>
        <h3 className="mb-3 font-bold text-white">Pros</h3>
        <ul className="space-y-2 text-sm text-slate-400">
          {tool.pros.map((pro) => <li key={pro} className="flex gap-2"><SafeIcon name="Plus" className="mt-0.5 shrink-0 text-emerald-400" />{pro}</li>)}
        </ul>
      </div>
      <div>
        <h3 className="mb-3 font-bold text-white">Cons</h3>
        <ul className="space-y-2 text-sm text-slate-400">
          {tool.cons.map((con) => <li key={con} className="flex gap-2"><SafeIcon name="Minus" className="mt-0.5 shrink-0 text-amber-400" />{con}</li>)}
        </ul>
      </div>
    </div>
  </article>
);

export default ComparisonToolCard;